import React from "react";
import { AnalyticsApi } from "../../api/user";
import { Details, WeightUnits } from "../../models/Details";
import { Util } from "../../models/Util";

interface WeightProp {
	detail: Details;
	valueSelected(response?: any): void;
}

const Weight: React.FC<WeightProp> = ({ detail, valueSelected }): JSX.Element => {
	const [weightUnit, setWeightUnit] = React.useState(WeightUnits.lbs);
	const [weight, setWeight] = React.useState({ weightLbs: 0, weightKg: 0 });
	const [enabled, setEnabled] = React.useState(false);

	const valueClicked = () => {
		AnalyticsApi.logEvent('Weight Added');
		detail.weight!.selectedUnit = weightUnit;
		valueSelected(weight);
	};

	const selectUnit = (unit: WeightUnits) => {
		setWeightUnit(unit);
	};

	const changeWeightLbs = (event: any) => {
		let newWeight = { weightLbs: parseInt(event.target.value), weightKg: weight.weightKg, selectedUnit: weightUnit };
		const weightConverted = Util.convertLbsToKg(event.target.value);
		newWeight.weightKg = weightConverted;

		checkValidity(newWeight);
	};

	const changeWeightKg = (event: any) => {
		let newWeight = { weightLbs: weight.weightLbs, weightKg: parseFloat(event.target.value), selectedUnit: weightUnit };
		const weightConverted = Util.convertKgToLbs(event.target.value);
		newWeight.weightLbs = weightConverted;

		checkValidity(newWeight);
	};

	const checkValidity = (newWeight: any) => {
		setWeight(newWeight);
		if (detail.setWeight(newWeight)) {
			setEnabled(true);
		} else {
			setEnabled(false);
		}
	};

	React.useEffect(() => {
		if (typeof detail.weight !== "undefined") {
			checkValidity(detail.weight);
			setWeightUnit(detail.weight.selectedUnit!);
		}
	}, []);

	return (
		<div className="content">
			<div className="inputDiv">
				<div className="large-input-inner-inline">
					{weightUnit === WeightUnits.lbs ? (
						<input
							type="number"
							min="50"
							max="500"
							className="normalInput largeNumber"
							value={weight.weightLbs === 0 ? "" : weight.weightLbs.toString()}
							onChange={changeWeightLbs}
						/>
					) : (
						<input
							type="number"
							min="23"
							max="227"
							className="normalInput largeNumber"
							value={weight.weightKg === 0 ? "" : weight.weightKg.toString()}
							onChange={changeWeightKg}
						/>
					)}

					<div
						className={weightUnit === WeightUnits.lbs ? "active" : ""}
						onClick={(e) => {
							selectUnit(WeightUnits.lbs);
						}}
					>
						lbs
					</div>
					<div
						className={weightUnit === WeightUnits.kg ? "active" : ""}
						onClick={(e) => {
							selectUnit(WeightUnits.kg);
						}}
					>
						kg
					</div>
				</div>
			</div>
			<div className="smallSubtext">
				{weightUnit === WeightUnits.lbs ? "Valid weight is 50-500 lbs" : "Valid weight is 23-227 kg"}
			</div>

			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default Weight;
